<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            Editar Operador
            <router-link :to="{ name: 'Operadores' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CRow>
              <CCol sm="6" md="6" lg="6">
                <CInput
                  :value.sync="$v.clave.$model"
                  :isValid="checkIfValid('clave')"
                  label="Clave:"
                  placeholder="Clave..."
                  invalidFeedback="Campo requerido, debe tener maximo 4 caracteres"
                />
              </CCol>
              <CCol sm="6" md="6" lg="6">
                <label>Trabajador:</label>
                <v-select
                  class="root-location-input"
                  v-model="trabajador_id"
                  :options="trabajadores"
                  placeholder="Trabajador ..."
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>
            <hr class="my-4 line" />
            <CRow class="mb-3">
              <CCol md="5" lg="5">
                <CInput
                  :isValid="checkIfValid('cubeta')"
                  :value.sync="$v.cubeta.$model"
                  placeholder="Cubeta..."
                  invalidFeedback="Campo requerido, debe tener maximo 3 caracteres"
                ></CInput>
              </CCol>
              <CCol alignHorizontal="end" md="2" lg="2">
                <CButton
                  @click="addCubeta()"
                  class="float-right"
                  color="success"
                  square
                  >Agregar</CButton
                >
              </CCol>
            </CRow>

            <CDataTable
              hover
              sorter
              bordered
              small
              fixed
              :items="cubetas"
              :fields="fieldsModal"
            >
              <template #cancel="{index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="deleteCubeta(index)"
                    >Borrar</CButton
                  >
                </td>
              </template>
            </CDataTable>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                  >Guardado con éxito.</CAlert
                >
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Operadores' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>
            <CButton
              @click="addOperador()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
            <!-- </router-link> -->
          </CCardFooter>
        </CCard>
      </CCol>

      <CModal
        size="sm"
        title="Cultivo"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

const fieldsModal = [
  { key: "nombre", _style: "width:40%" },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];
// const fieldsModal2 = [
//   { key: "nombre", label: "Etapas", _style: "width:40%" },
//   {
//     key: "cancel",
//     label: "",
//     _style: "width:1%",
//     sorter: false,
//     filter: false
//   }
// ];

export default {
  name: "EditarOperador",
  components: {
    vSelect,
  },
  data() {
    return {
      id: this.$route.params.id,
      clave: '',
      cubeta: '',
      cubetas: [],
      trabajador_id: 0,
      trabajadores: [],
      fieldsModal,
      warningModal: false,
      isLoading: false,
      isLoadingPage: true,
      currentAlertCounter: 0,
      error: "",
    };
  },
  mixins: [validationMixin],
  validations: {
    clave: {
      required,
      maxLength: maxLength(4)
    },
    cubeta: {
      required,
      maxLength: maxLength(3)
    },
  },
  watch: {
    ubicacionRaiz() {
      this.updateAllInfo();
    }
  },
  created() {
    this.updateAllInfo()
  },
  computed: {
    isValidOperador() {
      return !this.$v.clave.$invalid;
    },
    isValidCubeta() {
      return !this.$v.cubeta.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
    }
  },
  methods: {
    updateAllInfo(){
      this.isLoadingPage = true;

      if(!this.ubicacionRaiz?.value) {
         this.warningModal = true
         this.error = "Favor de selecionar una ubicación raíz"
      }

      this.$store.dispatch('customHTTP', {
            schema: 'trabajadores',
            filter: {
              where: [
                {field: 'payload->ubicaciones', operator: 'regexp', value: `[[:<:]]${this.ubicacionRaiz.value}[[:>:]]` },
                {field: 'payload->suspendido', operator: '!=', value: true }
              ]
            }
          })
          .then(response => {
            this.trabajadores = response.data.map(trabajador => {
              return {
                id: trabajador.id,
                label: trabajador.payload.nombre,
              };
            })
          })

      this.$store.dispatch('customHTTP', {
        schema: 'operadores',
        "with-storage": ["*"],
        filter: {
          where: [{
            field: 'id',
            value: this.id,
            operator: '='
          }]
        }
      })
      .then(response => {
        this.item = response.data[0];
        this.clave = this.item.payload.clave;
        debugger
        this.trabajador_id = this.item.payload.trabajador_id?{label: this.item.payload._relaciones.trabajador.payload.nombre,id:this.item.id}:null
        
        this.cubetas = this.item.payload.cubetas.map(cubeta => {
          return {
            nombre: cubeta
          }
        });
      })
      .finally(() => (this.isLoadingPage = false))

    },
    addCubeta() {
      this.validateCubeta();

      if (this.isValidCubeta) {
        this.cubetas.push({
          nombre: this.cubeta
        });
        this.resetCubeta();
      }
    },
    deleteCubeta(index) {
      if (index !== -1) {
        this.cubetas.splice(index, 1);
      }
    },
    deleteEtapa(index) {
      if (index !== -1) {
        this.etapas.splice(index, 1);
      }
    },
    addOperador() {
      this.validateOperador();
      if (this.isValidOperador) {
        this.isLoading = true;
        this.$store
          .dispatch("customRemplazarHTTP", {
            schema: "operadores",
            id: this.id,
            payload: {
              clave: this.clave,
              trabajador_id: this.trabajador_id?.id||0,
              cubetas: this.cubetas.map(cubeta => cubeta.nombre),
            }
          })
          .then(() => {
            this.$router.push({ name: "Operadores" });
          })
          .catch(rej => {
            this.error = rej.message;
            this.warningModal = true;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateCubeta() {
      this.$v.cubeta.$touch();
    },
    validateOperador() {
      this.$v.clave.$touch();
    },
    resetCubeta() {
      this.cubeta = '';
      this.$v.cubeta.$reset();
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
